module.exports = __webpack_public_path__ + "img/down_arrow.1a93ebd5.svg";